// import React from "react";
// import { Button } from "react-bootstrap";
// import '../../assets/ButtonForm.css';
// type Props = React.DetailedHTMLProps<
//   React.ButtonHTMLAttributes<HTMLButtonElement>,
//   HTMLButtonElement
// > & {
//   width?: string; // Add a width prop
//   style?: React.CSSProperties; // Add a style prop
// };

// export const FormButton = (props: Props) => (
//   <Button
//     {...props}
//     // variant="outline-primary"
//     className="formButton"
//     style={{
//       border:'1px solid lightgrey',
//       borderRadius: '10px',
//       width: props.width || '170px', // Use the provided width prop or default to '170px'
//       ...props.style // Merge the provided style prop with the default style
//     }}
//   >
//     {props.children}
//   </Button>
// );

// export default FormButton;


import React from "react";
import { Button } from "react-bootstrap";
import "../../assets/ButtonForm.css";


const FormButton = (props) => {
  return (
    <Button
      {...props}
      className="formButton"
      style={{
        border: "1px solid #D1D5DB", // Soft grey border
        borderRadius: "8px",
        width: props.width || "170px",
        padding: "10px 15px",
        fontSize: "16px",
        // fontWeight: "400",
        // backgroundColor: "#0056b3", // MUI-like blue
        // color: "#fff",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
        transition: "all 0.3s ease-in-out",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textTransform: "capitalize",
        ...props.style, // Merge custom styles
      }}
      // onMouseEnter={(e) =>
      //   (e.currentTarget.style.backgroundColor = "#004494") // Darker hover effect
      // }
      // onMouseLeave={(e) =>
      //   (e.currentTarget.style.backgroundColor = "#0056b3")
      // }
    >
      {props.children}
    </Button>
  );
};

export default FormButton;
